export default __webpack_public_path__ + "static/landingvideo2-compressed-2-0d54a2426ee8a3b303e611e4e8e9fad2.mp4";